/**
 * web/src/screens/Settings/plan.tsx — the Plan section of Settings (card
 * 32BEnNO6I2kx + card MudceTexpbq1): the billing row and the Share Pear
 * referral — moved verbatim out of index.tsx.
 */
import { SharePearCard } from '../../components/SharePearCard';
import type { BillingState } from './types';

export function PlanSection({ billing }: { billing: BillingState | null }) {
  return (
    <>
        {/* ── Plan (card 32BEnNO6I2kx) ───────────────────────────── */}
        {billing && (
          <section className="set-section" aria-labelledby="set-plan-title">
            <h3 className="set-section-title" id="set-plan-title">
              Plan
            </h3>
            <div className="set-row" data-testid="settings-plan-row">
              <div className="set-text">
                <div className="set-label">{billing.label}</div>
                <div className="set-note" data-testid="settings-plan-note">
                  {billing.note}
                </div>
              </div>
              <button
                type="button"
                className="pear-btn set-row-btn"
                id="btn-plan-action"
                onClick={() => {
                  // Both paths go through the sheet: Plus opens the portal from
                  // inside it, Essentials gets the two prices.
                  void import('../../lib/billing').then(m => m.announcePlusRequired());
                }}
              >
                {/* A grant has no Stripe customer, so there is no portal to
                    open — it offers Upgrade (convert to a real plan) the way
                    the trial row does (card Z7SGpA59WHSb). */}
                {billing.plus && !billing.trialing && !billing.granted ? 'Manage' : 'Upgrade'}
              </button>
            </div>
            {!billing.configured && (
              <p className="set-section-note">Billing is not switched on for this server yet.</p>
            )}
          </section>
        )}

        {/* ── Share Pear: the referral link (card 3MWZ8Zs7jA7e) ────────────
            Distinct from the invite above: that one brings the partner in,
            this one brings other COUPLES in — both sides earn 30 days of Plus
            (Jonathan 2026-10-17, JitsLab parity). Shown to any signed-in
            couple, paired or not: a link is shareable the day it is minted,
            and a friend who arrived on someone's link needs to see their own
            (the card is where the vested count lands).

            It lives on the PLAN tab (card sWEYh0kZBtRY, Jonathan 2026-10-20):
            it is a commercial offer about terms, so it sits beside the plan
            and its prices, not among the identity rows. Gated on the tab, not
            on `billing` — a couple whose billing state has not loaded still
            gets their own link. */}
        {/* Share Pear on the Plan tab (card sWEYh0kZBtRY). Tab-gated only, so
            the couple's link is there whether or not billing has loaded. */}
        <SharePearCard />
    </>
  );
}
